import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { NumberParam, useQueryParam, withDefault } from 'use-query-params';
import { Alert, AlertTitle } from '@material-ui/lab';
import SiteRouteAndParamPicker, { updateRouteAndParam } from '../../common/pickers/SiteRouteAndParamPicker';
import DocumentViewer from '../../documents/components/DocumentViewer';
import { useFindFileById } from '../../documents/hooks/useFindFileById';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
const StyledAlertTitle = styled(AlertTitle) `
  font-size: 15px;
  font-weight: 600;
`;
const SiteDocumentViewer = props => {
    var _a, _b;
    const component = useSubscribeComponentChanges(SiteDocumentViewerPlugin, props);
    const { editing, isHover, hoverProps } = useSiteContext();
    const params = useParams();
    const [versionId] = useQueryParam('ver', withDefault(NumberParam, undefined));
    const { routeParam } = component.props || {};
    const fileId = routeParam ? params[routeParam] : undefined;
    const { data: file, get } = useFindFileById(fileId, versionId);
    const classes = ['site-document-viewer'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    const className = classes.join(' ');
    const storageKey = (_b = (_a = file === null || file === void 0 ? void 0 : file.fileVersion) === null || _a === void 0 ? void 0 : _a.storageKey) !== null && _b !== void 0 ? _b : file === null || file === void 0 ? void 0 : file.storageKey;
    const showViewer = !!(file && storageKey);
    useEffect(() => {
        get();
    }, [get]);
    const content = (React.createElement(React.Fragment, null,
        editing && !showViewer && (React.createElement(Alert, { severity: 'info' },
            React.createElement(StyledAlertTitle, null, "Site Edit Mode"),
            "Site Document Viewer is displayed here.")),
        file && storageKey && (React.createElement(DocumentViewer, { title: file.name, fileSize: file.size, storageKey: storageKey, componentProps: Object.assign({ className }, hoverProps(component)) }))));
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteDocumentViewerPlugin }, props),
        editing ? (React.createElement("div", Object.assign({ className: className }, hoverProps(component)), content)) : (content),
        !editing && !showViewer && (React.createElement(Alert, { severity: 'error' },
            React.createElement(StyledAlertTitle, null, "No Document Available"),
            "Unable to load the Document for viewing."))));
};
export const SiteDocumentViewerConfigurator = props => {
    var _a, _b;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(SiteRouteAndParamPicker, { nearestOnly: true, component: component, routeId: (_a = component.props) === null || _a === void 0 ? void 0 : _a.routeId, routeParam: (_b = component.props) === null || _b === void 0 ? void 0 : _b.routeParam, siteRoutePickerProps: { label: 'Route' }, onChange: value => {
            updateRouteAndParam(value, 'props.routeId', 'props.routeParam').forEach(([path, value]) => update(path, value));
        } }));
};
export const SiteDocumentViewerPlugin = {
    name: 'Site Document Viewer',
    type: 'site-document-viewer',
    component: SiteDocumentViewer,
    configurator: SiteDocumentViewerConfigurator
};
//# sourceMappingURL=SiteDocumentViewerPlugin.js.map